import React, { useCallback, useMemo } from 'react'
import Select, { SingleValue } from 'react-select'

interface SelectWithSearchProps {
  value: string
  onChange: (value: string) => void
  options: {
    key: string
    label: string
  }[]
}

interface Option {
  value: string
  label: string
}

function SelectWithReact({
  value = '',
  onChange,
  options
}: SelectWithSearchProps) {
  // Transform the options to match react-select format (value-label pairs)
  const memoizedOptions = useMemo<Option[]>(
    () => options.map((option) => ({ value: option.key, label: option.label })),
    [options]
  )
  const handleSelectChange = useCallback(
    (selectedOption: SingleValue<Option>) => {
      if (selectedOption) {
        onChange(selectedOption.value)
      }
    },
    [onChange]
  )

  // Find the current value in the memoized options
  const selectedOption =
    memoizedOptions.find((option) => option.value === value) || null

  return (
    <Select
      value={selectedOption}
      onChange={handleSelectChange}
      options={memoizedOptions}
      isSearchable
      placeholder="Select an option..."
      classNamePrefix="assessment-select-dropdown"
      aria-label="Assessment option selector" // Add this line for screen readers
      tabIndex={0} // Ensures the select is focusable by keyboard
    />
  )
}

// Export the component wrapped in React.memo for optimization
export default React.memo(SelectWithReact)
